(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest('.product-form select[name="id"]');
    if (!variantSelect) return;

    const productPage = variantSelect.closest('.product-page');
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const isAvailable = selectedOption.dataset.available === 'true';
    const addToCart = productPage.querySelector('[data-add-to-cart]');
    const availability = productPage.querySelector('[data-product-availability]');

    if (addToCart) {
      addToCart.disabled = !isAvailable;
      addToCart.value = isAvailable ? 'Add to cart' : 'Sold out';
    }

    if (availability) availability.hidden = isAvailable;
  });

  } catch(e) { console.error(e); }
})();
})();
